module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "catalog-list__item",
    class: {
      "catalog-list__item_doubled": _vm.item.doubled
    }
  }, [_c('div', {
    staticClass: "catalog-list__item-inner"
  }, [_c(_vm.item.doubled ? "item-double" : "item-single", _vm._b({
    tag: "component",
    staticClass: "catalog-list__item-block",
    attrs: {
      "constrain-name-height": _vm.constrainNameHeight
    },
    on: {
      "delete": function($event) {
        return _vm.$emit("delete", _vm.index)
      },
      "cancel": function($event) {
        return _vm.$emit("cancel", _vm.index)
      },
      "contracts": function($event) {
        return _vm.$emit("contracts", $event)
      }
    }
  }, 'component', _vm.item.bind, false))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13546826","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/single_item/OrganizationSingleItem.vue
// module id = 558abecba0f9a39b4a82
// module chunks = 89